import { Leaf, Target, BarChart3, Globe } from "lucide-react";
import { motion } from "motion/react";

export function ComplianceCards() {
  const compliance = [
    {
      icon: Leaf,
      title: "ESG Ready",
      description: "Environmental, Social, and Governance reporting made simple with automated GEC tracking and verification.",
      features: ["Scope 2 emissions", "Carbon accounting", "Sustainability reports"],
      gradient: "from-emerald-500 to-emerald-600"
    },
    {
      icon: Target,
      title: "RE100 Compatible",
      description: "Meet RE100 commitments with 100% renewable electricity sourcing verified through hourly matching.",
      features: ["100% renewable", "Global standards", "Annual verification"],
      gradient: "from-cyan-500 to-cyan-600"
    },
    {
      icon: BarChart3,
      title: "SBTI Compatible",
      description: "Science Based Targets initiative aligned certificates for credible climate action and net-zero goals.",
      features: ["Net-zero pathway", "Science-based", "Progress tracking"],
      gradient: "from-emerald-500 to-cyan-600"
    },
    {
      icon: Globe,
      title: "CBAM",
      description: "CBAM reporting requirement of hourly green energy reporting is met by the 24/7 CFE standard, supporting India's Green Steel Initiative.",
      features: ["Hourly matching", "24/7 CFE standard", "Green Steel Initiative"],
      gradient: "from-emerald-500 to-cyan-600"
    }
  ];

  return (
    <section id="compliance" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold pb-2 bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">
            Global Sustainable Ready Framework
          </h2>
        </motion.div>

        {/* 4-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {compliance.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="h-full p-8 bg-gradient-to-br from-gray-50 to-white rounded-2xl border-2 border-gray-200 hover:border-transparent hover:shadow-2xl transition-all">
                <div className={`w-16 h-16 bg-gradient-to-br ${item.gradient} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                  <item.icon className="w-8 h-8 text-white" />
                </div>
                
                <h3 className="text-xl font-semibold mb-3 text-gray-900">
                  {item.title}
                </h3>
                
                <p className="text-gray-600 mb-6">
                  {item.description}
                </p>

                <ul className="space-y-2">
                  {item.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                      <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${item.gradient}`}></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
        
      </div>
    </section>
  );
}